import { Injectable } from "@angular/core";
import { BehaviorSubject, from, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { RequestsService } from "src/app/_shared/services/requests.service";
import { environment } from "src/environments/environment";
import { FarmerAngularFireDatabase } from "../../usage/firebase";
import {
  Banner,
  Promotion,
  PromotionOrder,
  PromotionStats,
} from "../agrishop.interface";

@Injectable({
  providedIn: "root",
})
export class PromotionService {
  promotions$: BehaviorSubject<Promotion[]> = new BehaviorSubject([]);
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor(
    private farmerdb: FarmerAngularFireDatabase,
    private requestService: RequestsService
  ) {
    this.isLoading$.next(true);
    this.getPromotionList().subscribe((value: Promotion[]) => {
      this.isLoading$.next(false);
      this.promotions$.next(value);
    });
  }

  getPromotionList(): BehaviorSubject<Promotion[]> {
    return this.farmerdb
      .list(`${environment.firebaseNodes.agrishop}/promotions`)
      .valueChanges() as BehaviorSubject<Promotion[]>;
  }

  createPromotion(promotion: Partial<Promotion>): Observable<Promotion> {
    return this.requestService
      .dash_post(`promotions`, promotion, true)
      .pipe(map((res) => res.data));
  }

  deletePromotion(promotion: string): Observable<any> {
    return this.requestService
      .dash_delete(promotion, `promotions`, true)
      .pipe(map((res) => res.data));
  }

  patchPromotion(id: string, data: Partial<Promotion>): Observable<Promotion> {
    return this.requestService
      .dash_patch(`promotions/${id}`, data, true)
      .pipe(map((res) => res.data));
  }

  putPromotion(id: string, data: Promotion): Observable<Promotion> {
    return this.requestService
      .dash_put(`promotions/${id}`, data, true)
      .pipe(map((res) => res.data));
  }

  getPromotionOrders(id: string): Observable<PromotionOrder[]> {
    return this.requestService
      .dash_get(`promotions/${id}/orders`, null, true)
      .pipe(map((res) => res.data));
  }
  getPromotionStats(id: string): Observable<PromotionStats> {
    return this.requestService
      .dash_get(`promotions/${id}/stats`, null, true)
      .pipe(map((res) => res.data));
  }
}
